export default __webpack_public_path__ + "assets/img/KYCUpdate1.f0c9990e.svg";